import { render, staticRenderFns } from "./ApiDocumentation.vue?vue&type=template&id=f9f4a716&"
import script from "./ApiDocumentation.vue?vue&type=script&lang=js&"
export * from "./ApiDocumentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports